//#region src/constant.ts
const FEDERATION_SUPPORTED_TYPES = ["script"];

//#endregion
export { FEDERATION_SUPPORTED_TYPES };
//# sourceMappingURL=constant.js.map